import {isEmpty, isNumber} from 'lodash';

const TECHNICAL_GROUP_FORM = {
  'groupId': 'Código Primario',
  'description': 'Descripción',
  'area': 'Area',
  'status': 'Estado',
};

const TECHNICAL_FORM = {
  'technicianId': 'Identificacion tecnico',
  'description': 'Descripción',
  'area': 'Area',
  'status': 'Estado',
};

const validateFieldsForm = (technicalFields, errorFields) => {
  let error = {
    'field': '',
    'error': false,
  };
  const errorArr = Object.keys(errorFields);
  errorArr.forEach((errorName) => {
    const field = technicalFields[errorName];
    const selectField =
      isNumber(field) && isNaN(field) === false ? `${field}` : field;
    if (isEmpty(selectField)) {
      error = {
        'field': errorFields[errorName],
        'error': true,
      };
    }
  });

  return error;
};

export const validateErrors = (type, technicalForm) => {
  const baseForm = type === 'technician' ? TECHNICAL_FORM : TECHNICAL_GROUP_FORM;
  const validateForm = validateFieldsForm(technicalForm, baseForm);

  if (validateForm.error) {
    return {
      'error': true,
      'message': `El campo ${validateForm.field} es requerido`,
    };
  }

  return {
    'error': false,
    'message': null,
  };
};

export const parseAreas = (list) => {
  return list.map((area) => ({
    'key': area.primaryCode,
    'text': area.description,
    'value': area.primaryCode,
  }));
};

export const parseUsers = (list) => {
  return list.map((user, idx) => ({
    'key': idx,
    'text': user.username,
    'value': user.username,
  }));
};

export const parseTechnicianGroups = (list) => {
  return list.map((group, idx) => ({
    'key': idx,
    'text': group.groupId,
    'value': group.groupId,
  }));
};
